<template>
  <div class="row">
    <div class="col-sm-10">
      <product-select v-model="productRow.product"
        @input="$emit('productSelected')"
      />
    </div>
    <div class="col-2">
      <div class="form-group">
        <label for="quantity">Menge</label>
        <input type="number" class="form-control" id="quantity"
          v-model.number="productRow.quantity"
        >
      </div>
    </div>
  </div>
</template>

<script>
import ProductSelect from 'src/components/product-select'

export default {
  components: { ProductSelect },
  props: ['productRow']
}
</script>

<style>
</style>
